import { type FC } from 'react'

import { Modal } from '@/components/elements'
import { MENU } from '@/constants/common/message.constants'
import { type PartnerToSubPartnerEntity } from '@/libs/api'

import { SubPartnerCreateModalContent } from './SubPartnerCreateModalContent'

type Props = {
  open: boolean
  tenantKey: string
  partnerId: number
  onSuccess: (subPartnerEntity: PartnerToSubPartnerEntity) => Promise<void>
  onClose: () => void
}

export const SubPartnerCreateModal: FC<Props> = ({
  open,
  tenantKey,
  partnerId,
  onSuccess,
  onClose
}) => {
  return (
    <Modal
      title={MENU.CREATING_SUB_PARTNER}
      zIndex={1999}
      width={860}
      open={open}
      onCancel={onClose}
    >
      <SubPartnerCreateModalContent
        tenantKey={tenantKey}
        onSuccess={onSuccess}
        onCancel={onClose}
        partnerId={partnerId}
      />
    </Modal>
  )
}
